import { render, staticRenderFns } from "./PqrForm.vue?vue&type=template&id=30658f13"
import script from "./PqrForm.vue?vue&type=script&lang=js"
export * from "./PqrForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports